import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { ChangeLogs } from '@ui/src';
import { useAppSelector } from '@store';
import useProblemExchangeTransaction from '../hooks/use-exchange';

const InternalTransactionChangeLog = (): React.JSX.Element => {
  const { changeLogs, changeLogsPagination } = useAppSelector(
    (state) => state.customersProblemTransactions.exchange,
  );
  const { users } = useAppSelector((state) => state.administrationDictionaries);
  const { activePermissions } = useAppSelector((state) => state.root);

  const { transactionId } = useParams();

  const { getChangeLogsAction, changeLogsIsFetching, changeLogsIsLoading } =
    useProblemExchangeTransaction({ transactionId });

  useEffect(() => {
    getChangeLogsAction();
  }, []);

  return (
    <ChangeLogs
      entityType="TRANSACTION"
      entityId={transactionId as string}
      changeLogsIsLoading={changeLogsIsLoading}
      changeLogs={changeLogs}
      activePermission={activePermissions}
      users={users}
      pagination={changeLogsPagination}
      changeLogsIsFetching={changeLogsIsFetching}
      getChangeLogs={getChangeLogsAction}
    />
  );
};

export default InternalTransactionChangeLog;
